// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container[data-v-424c91f0]{width:100%}.container .mobile-panel[data-v-424c91f0]{margin-top:1px}.section-tabs[data-v-424c91f0]{padding:10px 0 32px;background:#f1f2f3}@media(max-width:767px){.section-tabs[data-v-424c91f0]{padding:1px 0 20px;background:#fff}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
